import { useRef } from 'react';

export const useLastDifferent = <T>(newVal: T) => {
    const lastRef = useRef<T>(newVal);
    const oldRef = useRef<T>(newVal);
    if (newVal !== lastRef.current) {
        oldRef.current = lastRef.current;
        lastRef.current = newVal;
    }
    return [lastRef.current, oldRef.current] as const;
};
